import React from "react";

const defaultContextValue = null;

const AdminContext = React.createContext<any>(defaultContextValue);

export default AdminContext;
